const mutations = {
  SET_ESCUELA(state, data) {
    state.escuela_data = data;
  },
};

export default mutations;
